const serverURL = "https://dolphinflashcards.com/api/";
// const serverURL = "http://127.0.0.1:8080/api/";
// const serverURL = "/api/";
export default serverURL;
